import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import DisciplesPage from "@/pages/DisciplesPage";
import AttendancePage from "@/pages/AttendancePage";
import NotificationsPage from "@/pages/NotificationsPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ProfilePage from "@/pages/ProfilePage";
import EventsPage from "@/pages/EventsPage";
import PrayerRequestsPage from "@/pages/PrayerRequestsPage";
import DiscipleDashboard from "@/pages/DiscipleDashboard";
import UserManagementPage from "@/pages/UserManagementPage";
import ReportsPage from "@/pages/ReportsPage";

export default function Dashboard({ user, logout, onProfileUpdate }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const isDisciple = user.role === 'disciple';
  const isSuperAdmin = user.role === 'super_admin';

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar user={user} logout={logout} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      
      <div className={`flex-1 overflow-y-auto transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-20'}`}>
        <Routes>
          {isDisciple ? (
            <>
              <Route path="/" element={<Navigate to="/my-attendance" />} />
              <Route path="/my-attendance" element={<DiscipleDashboard user={user} />} />
              <Route path="/notifications" element={<NotificationsPage user={user} />} />
              <Route path="/events" element={<EventsPage user={user} />} />
              <Route path="/prayer-requests" element={<PrayerRequestsPage user={user} />} />
              <Route path="/profile" element={<ProfilePage user={user} onProfileUpdate={onProfileUpdate} />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Navigate to="/disciples" />} />
              <Route path="/disciples" element={<DisciplesPage user={user} />} />
              <Route path="/attendance" element={<AttendancePage user={user} />} />
              <Route path="/notifications" element={<NotificationsPage user={user} />} />
              <Route path="/analytics" element={<AnalyticsPage user={user} />} />
              <Route path="/events" element={<EventsPage user={user} />} />
              <Route path="/prayer-requests" element={<PrayerRequestsPage user={user} />} />
              <Route path="/profile" element={<ProfilePage user={user} onProfileUpdate={onProfileUpdate} />} />
              {isSuperAdmin && (
                <>
                  <Route path="/reports" element={<ReportsPage user={user} />} />
                  <Route path="/user-management" element={<UserManagementPage user={user} />} />
                </>
              )}
            </>
          )}
        </Routes>
      </div>
    </div>
  );
}